var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualAssistant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "766px",
    height: "834px",
    viewBox: "0 0 766 834",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "virtual_assistant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "virtual_assistant"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    x: 0,
    y: 799.43536,
    width: 766,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    fillRule: "nonzero",
    x: 706.17122,
    y: 776.71649,
    width: 23.36134,
    height: 23.36134
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    fillRule: "nonzero",
    transform: "translate(113.784695, 784.951718) rotate(-38.976870) translate(-113.784695, -784.951718) ",
    x: 102.104025,
    y: 773.271048,
    width: 23.36134,
    height: 23.36134
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    x: 382,
    y: 124.07167,
    width: 2,
    height: 328
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    x: 495,
    y: 155.07167,
    width: 132,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    x: 139,
    y: 155.07167,
    width: 132,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41016,51.98378 L110.58984,50.15956 C161.49658,27.25966 206.22217,27.28065 243.52393,50.21962 L242.47607,51.92372 C205.77344,29.35243 161.67676,29.37343 111.41016,51.98378 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(177.056885, 42.491890) rotate(-24.000000) translate(-177.056885, -42.491890) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.41016,45.98378 L510.58984,44.15956 C561.49707,21.26015 606.22168,21.28114 643.52344,44.21962 L642.47656,45.92372 C605.77246,23.35194 561.67773,23.37196 511.41016,45.98378 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero",
    transform: "translate(577.056640, 36.492074) rotate(24.000000) translate(-577.056640, -36.492074) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 205,
    cy: 124.07167,
    r: 31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 561,
    cy: 124.07167,
    r: 31
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero",
    cx: 68,
    cy: 355.07167,
    r: 58
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero",
    cx: 698,
    cy: 355.07167,
    r: 58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.54492,652.73768 C387.82617,652.73768 382.91892,652.56968 377.93359,652.23968 C367.661169,651.51891 357.447647,650.119698 347.35986,648.0512 C265.13818,631.27776 204.90723,574.36761 204.30859,573.79436 L205.69141,572.34905 C206.28613,572.91839 266.11963,629.43694 347.75977,646.09222 C357.760124,648.142325 367.885061,649.529135 378.06836,650.24358 C383.51855,650.60589 388.87695,650.77679 393.99219,650.73186 C404.66054,650.672057 415.308126,649.783645 425.83887,648.07464 C474.13574,640.19476 519.36914,614.72601 560.28125,572.37737 L561.71875,573.76604 C520.50098,616.43304 474.89258,642.09804 426.16113,650.04925 C415.528302,651.774422 404.777563,652.671321 394.00586,652.73186 C393.52148,652.73573 393.0332,652.73768 392.54492,652.73768 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,414.07167 C30.444637,414.07167 0,383.627033 0,346.07167 C0,308.516307 30.444637,278.07167 68,278.07167 C105.555363,278.07167 136,308.516307 136,346.07167 C135.957412,383.609378 105.537708,414.029082 68,414.07167 Z M68,280.07167 C31.5492065,280.07167 2,309.620877 2,346.07167 C2,382.522463 31.5492065,412.07167 68,412.07167 C104.450793,412.07167 134,382.522463 134,346.07167 C133.958844,309.637937 104.433733,280.112826 68,280.07167 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698,414.07167 C660.444637,414.07167 630,383.627033 630,346.07167 C630,308.516307 660.444637,278.07167 698,278.07167 C735.555363,278.07167 766,308.516307 766,346.07167 C765.957412,383.609378 735.537708,414.029082 698,414.07167 Z M698,280.07167 C661.549207,280.07167 632,309.620877 632,346.07167 C632,382.522463 661.549207,412.07167 698,412.07167 C734.450793,412.07167 764,382.522463 764,346.07167 C763.958844,309.637937 734.433733,280.112826 698,280.07167 Z",
    id: "Shape",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 351,
    cy: 456.07167,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3F3D56",
    fillRule: "nonzero",
    cx: 415,
    cy: 456.07167,
    r: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 383,
    cy: 714.07167,
    rx: 25,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.097468,560.219125 C601.514663,544.97519 577.504636,533.214522 549.394476,537.82434 C521.284316,542.434159 498.243882,559.032595 498.243882,602.602868 C498.243882,634 532.656926,661.85423 556,668.56511 C575.681726,668.56511 612.011572,654.901665 621.635941,626.605469 C631.260311,598.309272 621.635941,573.958758 612.097468,560.219125 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(458.620528, 565.175399) rotate(-72.000000) translate(-458.620528, -565.175399) translate(440.120528, 518.675399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3451531,29.0547957 C24.5918582,29.0547957 28.8451531,24.539043 28.8451531,18.9685799 C28.8451531,15.2549378 25.1772625,8.95034306 17.8414812,0.0547956615 C12.5105958,8.95034306 9.8451531,15.2549378 9.8451531,18.9685799 C9.8451531,24.539043 14.098448,29.0547957 19.3451531,29.0547957 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9250563,90.8930602 C28.8661818,90.8930602 36.9250563,82.5011743 36.9250563,72.1492585 C36.9250563,61.7973427 28.8661818,48.8930602 18.9250563,48.8930602 C8.98393078,48.8930602 0.925056273,61.7973427 0.925056273,72.1492585 C0.925056273,82.5011743 8.98393078,90.8930602 18.9250563,90.8930602 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 18.6775806,
    cy: 40.0067965,
    rx: 12.5,
    ry: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 10.2736027,
    y: 25.3580503,
    width: 17,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 9.41458097,
    y: 48.4444127,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 6.91105983,
    y: 85.6871992,
    width: 25,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(549.263158, 495.398206) rotate(-9.000000) translate(-549.263158, -495.398206) translate(530.763158, 446.398206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9542088,31.1052691 C23.2009139,31.1052691 27.4542088,26.2780852 27.4542088,20.3234522 C27.4542088,16.3536969 23.7863182,9.61430249 16.4505369,0.105269063 C11.1196515,9.61430249 8.4542088,16.3536969 8.4542088,20.3234522 C8.4542088,26.2780852 12.7075037,31.1052691 17.9542088,31.1052691 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4987008,94.8957877 C28.4398263,94.8957877 36.4987008,86.1042883 36.4987008,75.2594241 C36.4987008,64.4145599 28.4398263,50.8957877 18.4987008,50.8957877 C8.55757527,50.8957877 0.498700764,64.4145599 0.498700764,75.2594241 C0.498700764,86.1042883 8.55757527,94.8957877 18.4987008,94.8957877 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 18.8253544,
    cy: 42.0673382,
    rx: 12.5,
    ry: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 9.31772021,
    y: 27.2519306,
    width: 17,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 8.67048087,
    y: 50.5945003,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 5.26101508,
    y: 90.0344849,
    width: 25,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-79",
    transform: "translate(633.561466, 532.453317) rotate(43.000000) translate(-633.561466, -532.453317) translate(615.061466, 491.953317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7426374,25.4910182 C23.9893425,25.4910182 28.2426374,21.598128 28.2426374,16.7960046 C28.2426374,13.594589 24.5747467,8.15959354 17.2389655,0.491018199 C11.9080801,8.15959354 9.24263737,13.594589 9.24263737,16.7960046 C9.24263737,21.598128 13.4959322,25.4910182 18.7426374,25.4910182 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5519408,76.9743155 C28.4930663,76.9743155 36.5519408,69.7812705 36.5519408,60.9081998 C36.5519408,52.0351292 28.4930663,40.9743155 18.5519408,40.9743155 C8.61081534,40.9743155 0.551940832,52.0351292 0.551940832,60.9081998 C0.551940832,69.7812705 8.61081534,76.9743155 18.5519408,76.9743155 Z",
    id: "Oval",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2F2E41",
    cx: 17.6613081,
    cy: 33.8256223,
    rx: 12.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 9.50679546,
    y: 21.9321578,
    width: 17,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 8.54717438,
    y: 41.0370883,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#44FF46",
    x: 5.77599824,
    y: 74.0068932,
    width: 25,
    height: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M525.42556,769.99881 C525.124661,771.902913 524.687909,773.783047 524.11865,775.62481 C523.47754,777.42756 522.48775,779.09481 521.90156,780.91612 C520.03306,786.72178 522.62336,793.19495 526.76047,797.67617 C530.348167,801.546755 534.979128,804.296628 540.09475,805.59409 C543.861045,806.399983 547.702273,806.803643 551.55382,806.79828 C562.20425,807.15943 573.1287,807.48254 583.22062,804.05977 C586.409053,802.951749 589.488755,801.552663 592.42077,799.88021 C593.346513,799.439159 594.162101,798.796977 594.80801,798.00053 C595.484072,796.834015 595.784837,795.487731 595.66948,794.14441 C595.64683,789.62941 594.73148,785.13741 594.94883,780.62762 C595.0692,778.12962 595.53671,775.63362 595.30659,773.14332 C594.653932,767.348259 590.430676,762.588146 584.75459,761.24996 C581.856111,760.802597 578.906139,760.802759 576.00771,761.25044 C568.441992,761.97741 560.844057,762.31714 553.24365,762.2683 C545.47798,762.21873 537.76026,761.0333 530.03324,760.90951 C527.74814,760.8729 527.7943,761.57737 527.0668,763.78893 C526.396702,765.824406 525.848648,767.89805 525.42556,769.99881 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.4639,658.5125 C547.232776,660.495205 546.566641,662.402402 545.51308,664.09785 C544.16208,665.94538 541.95925,667.00102 540.50584,668.76913 C538.31815,671.43052 538.19258,675.17552 538.18357,678.62064 C538.17526,681.79435 538.23972,685.17946 540.00957,687.81388 C541.269225,689.450414 542.832581,690.828747 544.61405,691.87342 C551.2513,696.34634 558.42353,700.89956 566.42592,701.04707 C569.74161,701.10819 573.29677,700.25191 575.47845,697.75436 C576.420418,696.581221 577.161075,695.259828 577.67021,693.84408 C579.716372,688.800142 580.956729,683.465843 581.34584,678.0366 C581.640686,675.484259 581.402418,672.898502 580.64612,670.44302 C579.67397,667.73254 577.70829,665.50237 576.40912,662.93254 C574.873414,659.876747 574.311718,656.423515 574.79978,653.03854 C574.864414,652.800198 574.844455,652.546822 574.7433,652.32154 C574.5267,652.077104 574.208229,651.948059 573.88257,651.97277 L558.01512,650.8305 C556.537309,650.757062 555.065745,650.588715 553.60953,650.3265 C552.75416,650.15258 550.49492,648.93775 549.67931,649.26078 C548.1696,649.85868 547.77336,656.8921 547.4639,658.5125 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.4639,658.5125 C547.232776,660.495205 546.566641,662.402402 545.51308,664.09785 C544.16208,665.94538 541.95925,667.00102 540.50584,668.76913 C538.31815,671.43052 538.19258,675.17552 538.18357,678.62064 C538.17526,681.79435 538.23972,685.17946 540.00957,687.81388 C541.269225,689.450414 542.832581,690.828747 544.61405,691.87342 C551.2513,696.34634 558.42353,700.89956 566.42592,701.04707 C569.74161,701.10819 573.29677,700.25191 575.47845,697.75436 C576.420418,696.581221 577.161075,695.259828 577.67021,693.84408 C579.716372,688.800142 580.956729,683.465843 581.34584,678.0366 C581.640686,675.484259 581.402418,672.898502 580.64612,670.44302 C579.67397,667.73254 577.70829,665.50237 576.40912,662.93254 C574.873414,659.876747 574.311718,656.423515 574.79978,653.03854 C574.864414,652.800198 574.844455,652.546822 574.7433,652.32154 C574.5267,652.077104 574.208229,651.948059 573.88257,651.97277 L558.01512,650.8305 C556.537309,650.757062 555.065745,650.588715 553.60953,650.3265 C552.75416,650.15258 550.49492,648.93775 549.67931,649.26078 C548.1696,649.85868 547.77336,656.8921 547.4639,658.5125 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    fillRule: "nonzero",
    cx: 563.864788,
    cy: 613.85423,
    r: 48
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E5A5A5",
    cx: 528,
    cy: 632.5,
    rx: 1,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.729,689.50105 C551.878987,690.832827 553.26525,691.940551 554.81792,692.76839 C556.436574,693.437372 558.174913,693.768352 559.92615,693.741 C564.12248,693.859 568.67158,693.09013 571.59076,690.07325 C575.35376,686.18434 575.22976,679.91189 578.1793,675.37495 C578.416951,674.963611 578.741267,674.608915 579.12974,674.33548 C579.624485,674.066131 580.183607,673.937578 580.74631,673.9638 C584.47147,673.92897 587.71644,676.34501 590.64503,678.64749 C592.023381,679.596047 593.20628,680.80103 594.12918,682.19669 C594.708242,683.326544 595.104793,684.540944 595.30411,685.7948 C596.594539,692.923074 597.393445,700.131621 597.69518,707.36947 C597.95318,711.36104 598.21132,715.35647 598.19218,719.35631 C598.12901,732.53414 595.06605,745.49159 592.02018,758.31274 C591.62771,759.96474 591.09064,761.81129 589.58831,762.60258 C588.91865,762.90368 588.199387,763.079235 587.46631,763.12051 C578.759212,764.292616 569.998242,765.022104 561.2172,765.30616 C557.789673,765.358947 554.363633,765.275977 550.93908,765.05725 C550.349558,765.049466 549.765062,764.947573 549.20768,764.75542 C548.451201,764.392193 547.801109,763.840123 547.32013,763.15248 C542.56931,757.16583 542.28889,748.88919 542.31925,741.24659 C542.393503,722.56109 543.061113,703.89052 544.32208,685.23488 C544.42619,683.69506 544.44892,681.82498 543.3394,680.61366 C545.499745,683.815375 547.975297,686.792694 550.729,689.50105 L550.729,689.50105 Z",
    id: "Path",
    fill: "#D0CDE1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.79792,662.62143 C545.01167,664.04468 539.21499,667.57885 538.09592,668.75843 C531.84329,675.34908 520.43133,675.10178 514.71285,682.16088 C512.817819,684.74937 511.511963,687.721069 510.88685,690.8676 C509.79953,695.25549 509.21895,700.04088 511.04041,704.17828 C512.79307,708.15939 516.48261,710.9117 518.98756,714.46785 C521.73797,718.37246 522.97456,723.11345 524.15972,727.74014 C525.03472,731.15632 525.91703,734.65714 525.57625,738.16708 C525.18879,742.15782 523.25763,745.81194 522.11742,749.65591 C520.97721,753.49988 520.78042,758.07811 523.41675,761.09902 C525.35359,763.31838 528.39156,764.19822 531.29534,764.69317 C535.014532,765.252007 538.764939,765.5785 542.52475,765.67075 C545.84418,765.81741 549.50315,765.84592 552.05496,763.71794 C553.985714,761.894116 555.072839,759.350715 555.057034,756.6948 C555.025739,754.072401 554.767085,751.457651 554.28381,748.87998 C553.92995,746.18529 553.79396,743.46712 553.68018,740.75168 C553.169647,728.567827 553.09998,716.37614 553.47118,704.17662 C553.658207,701.641115 553.53388,699.092247 553.10098,696.58698 C552.38909,693.32355 550.62536,690.40706 549.15369,687.40857 C546.212449,681.761124 544.880248,675.413821 545.30269,669.06039 C545.74831,662.53113 548.59572,657.55678 545.79792,662.62143 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.48815,663.11674 C579.68574,664.3476 583.75515,664.75337 585.27856,665.54606 C586.71155,666.208028 588.206857,666.725752 589.74238,667.09158 C595.299336,668.694683 600.585008,671.120615 605.42368,674.28873 C606.429046,674.87692 607.317894,675.644674 608.04603,676.55382 C608.813093,677.80167 609.307449,679.197699 609.49662,680.65019 C610.392251,684.315951 610.838199,688.077128 610.82462,691.85069 C610.64669,695.84811 609.44262,699.71961 608.24806,703.53853 L603.7847,717.80794 C600.4531,728.45907 597.10038,739.21506 596.16292,750.33564 C595.64428,756.498937 595.87487,762.702385 596.84964,768.81017 C597.035041,769.411273 596.953037,770.063074 596.62452,770.59952 C596.330462,770.890185 595.943569,771.068206 595.53152,771.10244 C593.3773,771.43928 591.29252,770.34088 589.34076,769.36895 C583.375258,766.400228 577.008809,764.317081 570.44227,763.18523 C573.008268,759.476949 574.98806,755.395722 576.31208,751.08496 C577.06402,748.347743 577.656173,745.569121 578.08554,742.76316 L580.16185,730.75438 C581.006592,726.365111 581.60125,721.931388 581.94295,717.47465 C582.099913,715.802136 582.002473,714.115492 581.65395,712.47218 C581.175458,710.908344 580.540112,709.396881 579.7576,707.96084 C576.33574,700.84302 574.73019,692.7203 576.0766,684.93828 C576.66582,681.53264 577.81083,678.12244 577.33338,674.69934 C576.87433,671.40818 577.35138,668.85034 576.50697,665.59327 C574.749084,658.812936 575.400345,659.712119 576.0766,660.54091 C576.734166,661.346796 577.377395,661.975144 578.48815,663.11674 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.6536,693.41477 C513.0936,696.65197 510.4856,699.40977 509.59791,702.89187 C509.252507,704.519254 509.104504,706.182336 509.1571,707.84514 C509.003093,710.351141 509.251174,712.86564 509.89193,715.29323 C510.38736,716.82878 511.19337,718.2449 511.77403,719.75029 C512.583429,721.85346 512.944021,724.102662 512.83265,726.35345 C512.67599,729.47168 511.61665,732.49855 511.53386,735.61961 C511.40367,740.52775 513.67386,745.1418 515.88896,749.52361 C517.01752,746.728844 519.322029,744.574648 522.186456,743.636874 C525.050883,742.699099 528.183175,743.07336 530.74602,744.65961 C531.253354,744.036534 531.494024,743.238277 531.41564,742.43861 C531.579367,736.74441 531.737303,731.05005 531.88945,725.35553 C532.12923,716.54853 532.35766,707.62395 530.33172,699.04982 C529.570579,695.126982 527.873424,691.445949 525.38455,688.31969 C524.01067,686.73869 519.34672,682.57416 517.09146,684.34532 C516.07725,685.14183 516.31429,687.31 516.15359,688.40791 C515.911022,690.143411 515.405211,691.831772 514.6536,693.41477 L514.6536,693.41477 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.28063,684.08595 C611.908141,686.420272 612.176766,688.836494 612.07728,691.25164 C612.10728,696.174107 612.042043,701.09593 611.88157,706.01711 C611.906115,708.541127 611.583374,711.056526 610.92242,713.49259 C610.41864,715.07677 609.64122,716.56232 609.12094,718.14115 C607.5617,722.87283 608.41362,728.00478 608.54733,732.98495 C608.64172,734.596827 608.504163,736.213906 608.13887,737.78668 C607.316,740.874 605.10463,743.36868 603.56119,746.16622 C602.09535,748.82315 601.21087,751.80128 599.46019,754.2798 C597.70951,756.75832 594.67885,758.72223 591.74133,757.96136 C589.5156,757.38486 587.93409,755.41478 586.84017,753.39251 C584.453099,748.946181 583.636701,743.824291 584.52317,738.85618 C585.62141,732.81167 589.17193,727.4494 590.4524,721.44085 C592.21077,713.18979 589.5384,704.67535 589.61787,696.23938 C589.581589,694.91701 589.760937,693.597558 590.14887,692.33285 C590.974248,690.461579 592.143398,688.761783 593.59564,687.32168 C595.260894,685.390383 596.807859,683.360173 598.22807,681.24216 C599.18207,679.81936 600.47781,676.15992 602.16922,675.85565 C605.94554,675.17636 610.34373,681.16845 611.28063,684.08595 Z",
    id: "Path",
    fill: "#44FF46",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.05894,766.32928 C492.970706,765.804429 490.819066,765.575698 488.66716,765.6498 C484.093375,765.90262 479.848967,768.109373 477.014786,771.708101 C474.180606,775.30683 473.030166,779.950239 473.85643,784.45587 C474.377873,786.868516 475.230187,789.197541 476.38919,791.37687 C478.0843,794.81687 480.11736,798.24906 483.25546,800.45352 C485.146217,801.665636 487.182134,802.634745 489.31513,803.33796 L505.84286,809.56425 C508.27428,810.48025 510.70606,811.39625 513.16154,812.24562 C525.49763,816.509615 538.358923,819.066466 551.38791,819.8451 C555.352543,820.216575 559.350035,820.014015 563.25681,819.24368 C564.201211,819.120486 565.066839,818.652828 565.68754,817.93047 C566.002579,817.381578 566.188319,816.76808 566.23064,816.13662 L567.24764,809.01678 C567.475279,808.025308 567.445522,806.992087 567.1612,806.01536 C566.562972,804.867782 565.595024,803.955631 564.41399,803.42651 C553.54817,797.18572 540.86099,793.74273 531.71511,785.17735 C529.56202,783.16092 527.76022,779.96468 525.14424,778.59496 C522.17774,777.04172 518.68413,776.15523 515.61784,774.72396 C508.9146,771.59497 502.324,767.9993 495.05894,766.32928 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.55948,775.92786 C517.40134,777.75839 542.06568,790.4404 546.29322,794.86828 C545.72656,795.07244 526.50022,784.29773 525.92336,784.12459 C520.635138,782.672236 515.456399,780.847228 510.426,778.66326 C509.42415,778.1999 503.91741,776.022 504.16679,774.75795 C504.4482,773.33155 510.52239,775.60289 511.55948,775.92786 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.44035,823.53767 C584.771865,823.561985 585.100937,823.465138 585.36643,823.26512 C585.601676,822.962961 585.705943,822.579092 585.65589,822.19944 L585.62868,812.49968 C582.76856,811.316966 579.741726,810.586797 576.65694,810.33541 L562.368,808.42547 C562.69629,808.46935 560.13385,814.57982 560.52675,815.39559 C561.21924,816.83338 566.5114,818.10766 568.00498,818.78653 C573.19718,821.14651 578.59254,823.74102 584.44035,823.53767 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.60905,812.46612 C536.91117,812.89582 533.89999,813.27567 532.15281,815.37579 C529.93714,818.03903 530.88037,822.00926 531.93731,825.30849 C532.067487,826.168793 532.540239,826.939813 533.247933,827.446011 C533.955628,827.952208 534.838036,828.150503 535.69426,827.99575 C538.15468,828.15155 540.77307,828.2736 542.92284,827.06675 C543.896571,826.423263 544.834,825.72646 545.73084,824.97953 C547.316107,823.92468 549.058681,823.127999 550.89359,822.61919 C554.266791,821.558147 557.739068,820.842573 561.25693,820.48349 C562.643081,820.420336 564.015274,820.178449 565.33947,819.76383 C566.680161,819.331748 567.743063,818.299793 568.21456,816.97245 C568.71256,815.20972 567.68803,813.41256 566.70547,811.86667 C565.573319,809.841943 564.103622,808.025486 562.35979,806.49567 C559.69732,804.42751 558.38028,806.01515 555.69835,807.33861 C550.622285,809.84385 545.198662,811.572308 539.60905,812.46612 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.55869,814.89622 L515.42817,809.83304 C513.373484,809.117544 511.226513,808.701502 509.05329,808.59771 C506.852001,808.507428 504.718585,809.370197 503.19887,810.96528 C501.87051,812.52428 501.49031,814.65508 501.15916,816.67628 L500.45077,821.00002 C499.978379,823.179743 499.8446,825.419231 500.05414,827.63969 C500.285162,829.889983 501.540715,831.908108 503.45728,833.10976 C505.82781,834.40308 508.7332,833.77138 511.37885,833.23041 C516.722865,832.138083 522.158455,831.555195 527.61257,831.48958 C529.663,831.46506 531.81365,831.49075 533.62549,830.53048 C535.760671,829.264669 537.132132,827.025264 537.28926,824.54805 C537.62636,820.85464 536.39528,816.03019 532.55869,814.89622 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.17409,810.48397 C593.3948,810.09476 595.35471,808.83264 597.48263,808.08766 C600.4778,807.03905 603.72363,807.03907 606.89701,807.05066 C608.063828,806.944064 609.236474,807.178924 610.27224,807.72666 C611.67007,808.65726 612.02833,810.5196 612.26601,812.18196 L613.70001,822.21173 C614.083533,824.082973 614.12323,826.0084 613.81716,827.89386 C613.479597,829.810922 612.126635,831.392953 610.28516,832.02386 C608.04516,832.60621 605.84916,831.17526 603.7341,830.23527 C598.44775,827.88583 592.30267,828.48627 586.7907,826.73033 C585.724877,826.516679 584.80171,825.85652 584.25495,824.91701 C584.06641,824.359937 583.999147,823.768994 584.05767,823.1838 C584.15206,819.95993 583.4721,815.55769 584.44267,812.47659 C585.31563,809.70561 588.69521,810.48397 591.17409,810.48397 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.426,762.29236 C630.848941,761.434023 634.397302,761.191577 637.90518,761.57636 C640.70668,761.88499 643.59308,762.66454 645.63848,764.60359 C648.12804,766.9637 648.92794,770.61366 648.99467,774.04346 C649.104101,780.87476 646.838366,787.532145 642.58448,792.87846 C641.545711,794.230705 640.310416,795.419876 638.91964,796.40646 C637.419341,797.34497 635.820325,798.115541 634.15146,798.70426 L597.13828,813.30336 C587.40093,817.14405 577.62921,820.99588 567.47264,823.52786 C566.911652,823.79868 566.265115,823.831664 565.679479,823.61934 C565.093843,823.407017 564.618665,822.967354 564.36158,822.39994 C561.118634,817.767699 558.398006,812.79097 556.24932,807.56053 C556.042833,807.308255 555.972288,806.97116 556.060288,806.657256 C556.148288,806.343352 556.383784,806.092054 556.69132,805.98388 L582.871,790.94182 C584.790637,789.940528 586.580179,788.707504 588.19952,787.27038 C589.330956,786.173882 590.257406,784.884074 590.93521,783.46174 C591.47788,782.32829 591.5285,779.65351 592.22166,778.81574 C592.90032,777.99547 595.22191,777.93001 596.29414,777.60738 C597.806322,777.144185 599.287208,776.584388 600.72766,775.93144 C606.58387,773.31157 611.79873,769.50502 617.41266,766.43744 C620.561375,764.637152 623.926107,763.244301 627.426,762.29236 L627.426,762.29236 Z",
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.58444,773.52567 C608.08667,776.9038 602.26286,780.00908 597.8051,783.47623 C596.28372,784.65953 570.92185,798.91823 570.56325,800.81196 C574.72208,801.51269 601.21425,782.9794 605.00465,781.13007 C608.731528,779.148983 612.243518,776.787754 615.48457,774.08407 C616.33307,773.42436 619.92899,771.44117 617.49322,770.70407 C616.12107,770.28893 613.59745,772.85036 612.58444,773.52567 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(651.000000, 711.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,4 L46,113.384586 C46,115.263906 44.8654517,115.532208 43.0215838,116.443754 C36.8003133,119.519202 21.4651555,124.999146 3.05352657,116.326104 C1.16357118,115.435813 0,115.134933 0,113.229586 L0,4.70086712 C0,4.70086712 23.3931668,13.1112814 46,4 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#44FF46",
    fill: "#3F3D56",
    cx: 23,
    cy: 4.5,
    rx: 23,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 49.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.38514286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.01823714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.91038571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.99115714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.63154571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.88330571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.80253429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.43723143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.91038571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.35646,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.01823714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.54508286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.43723143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.88330571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.88330571,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 51.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.00886571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.64196857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.53411714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.61488857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.25527714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.50703714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.42626571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.06096286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.53411714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 2.98019143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.64196857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.16881429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.06096286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.50703714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.50703714,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 53.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.48974,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.12284286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.01499143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.09576286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.73614286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.98791143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.90714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.54183714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.01499143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.46106571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.12284286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.64968857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.54183714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.98791143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.98791143,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 56.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.11347143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.74657429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.63872286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.71948571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.35987429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.61163429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.53087143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.16556,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.63872286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.08479714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.74657429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.27341143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.16556,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.61163429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.61163429,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 57.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.59434571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.22744,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.11958857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.20036,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.84074857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.09250857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.01173714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.64643429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.11958857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.56566286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.22744,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.75428571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.64643429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.09250857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.09250857,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 60.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.21806857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.85117143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.74332,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.82409143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.46448,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.71624,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.63546857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.27016571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.74332,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.18939429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.85117143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.37801714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.27016571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.71624,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.71624,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 62.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.7343375,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.38063,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.291365,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.3946525,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.04837375,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.3053875,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.2021,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.85002,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.291365,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.7467325,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.38063,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.939285,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.85002,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.3053875,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.3053875,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 64.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.32267429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.95577714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.84792571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.92868857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.56907714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.82083714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.74007429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.37476286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.84792571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.294,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.95577714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.48261429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.37476286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.82083714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.82083714,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 67.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 0.946405714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.5795,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.47164857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.55242,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.19280857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.44456857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.36379714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 3.99849429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.47164857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 2.91772286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.5795,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.10634571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 3.99849429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.44456857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.44456857,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 69.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.42727143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.06037429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.95252286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.03329429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.67368286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.92544286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.84467143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.47936857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.95252286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.39859714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.06037429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.58722,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.47936857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.92544286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.92544286,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 72.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.05100286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.68410571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.57625429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.65702571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.29740571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.54917429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.46840286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.1031,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.57625429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.02232857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.68410571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.21095143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.1031,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.54917429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.54917429,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 73.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.53187714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.16498,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.05712857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.13789143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.77828,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.03004,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.94927714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.58396571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.05712857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.50320286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.16498,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.69181714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.58396571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.03004,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.03004,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 76.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.15560857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.78870286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.68085143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.76162286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.40201143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.65377143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.573,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.20769714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.68085143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.12692571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.78870286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.31554857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.20769714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.65377143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.65377143,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 78.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.63647429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.26957714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.16172571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.24249714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.88288571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.13464571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.05387429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.68857143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.16172571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.6078,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.26957714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.79642286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.68857143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.13464571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.13464571,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 80.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.26020571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.89330857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.78545714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.86622857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.50660857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.75837714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.67760571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.31230286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.78545714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.23153143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.89330857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.42015429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.31230286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.75837714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.75837714,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 83.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 0.883937143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.51703143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.40918,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.48995143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.13034,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.3821,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.30132857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 3.93602571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.40918,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 2.85525429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.51703143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.04387714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 3.93602571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.3821,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.3821,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 85.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.36481143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.99790571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.89005429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.97082571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.61121429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.86297429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.78220286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.4169,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.89005429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.33612857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.99790571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.52475143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.4169,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.86297429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.86297429,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 87.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 0.988534286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.62163714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.51378571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.59455714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.23494571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.48670571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.40593429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.04063143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.51378571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 2.95986,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.62163714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.14848286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.04063143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.48670571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.48670571,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 89.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.46940857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.10251143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.99466,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.07543143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.71581143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.96758,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.88680857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.52150571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.99466,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.44073429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.10251143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.62935714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.52150571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.96758,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.96758,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 92.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.09314,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.72623429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.61838286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.69915429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.33954286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.59130286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.51053143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.14522857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.61838286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.06445714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.72623429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.25308,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.14522857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.59130286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.59130286,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 94.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.57401429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.20710857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.09925714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.18002857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.82041714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.07217714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.99140571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.62610286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.09925714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.54533143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.20710857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.73395429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.62610286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.07217714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.07217714,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 96.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.19773714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.83084,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.72298857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.80376,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.44414,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.69590857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.61513714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.24983429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.72298857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.16906286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.83084,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.35768571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.24983429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.69590857,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.69590857,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 98.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.7135825,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 2.359875,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 3.27061,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 4.3738975,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 5.02761875,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 5.2846325,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 4.181345,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.829265,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 3.27061,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.7259775,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 2.359875,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.91853,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.829265,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 5.2846325,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 5.2846325,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.8,
    transform: "translate(0.000000, 101.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 43.87703,
    cy: 1.30234286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 41.235,
    cy: 1.93543714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 37.97082,
    cy: 2.82758571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 32.11811,
    cy: 3.90835714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 25.94755,
    cy: 4.54874571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 19.55709,
    cy: 4.80050571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 10.38428,
    cy: 3.71973429,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 13.42349,
    cy: 4.35443143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 4.70675,
    cy: 2.82758571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.44122,
    cy: 3.27366,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.71034,
    cy: 1.93543714,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 34.98211,
    cy: 3.46228286,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 28.94379,
    cy: 4.35443143,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 22.39112,
    cy: 4.80050571,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 16.4304,
    cy: 4.80050571,
    rx: 1,
    ry: 1
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2F2E41",
    fillRule: "nonzero",
    points: "615.899008 570.143767 574.636175 548.85423 517.653285 557.563679 505.864788 608.85423 535.211367 607.741954 543.410359 588.898207 543.410359 607.43141 556.952399 606.917895 564.811397 576.91891 569.723786 608.85423 617.864788 607.886063"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    fillRule: "nonzero",
    x: 540.34955,
    y: 668.56511,
    width: 43.09167,
    height: 52.00719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.89266,759.01926 C520.798711,760.55915 522.086,761.839806 523.63055,762.73789 C525.684092,763.675785 528.055776,763.612218 530.05613,762.56567 C532.027595,761.508601 533.641328,759.890661 534.69326,757.91645 C536.86959,754.07337 537.32026,749.47471 537.04873,745.06654 C536.7772,740.65837 535.83592,736.31772 535.41933,731.92088 C535.11651,728.72468 535.09188,725.50942 535.06749,722.299 C534.992302,721.623886 535.133919,720.942362 535.47184,720.35309 C536.053728,719.774489 536.806445,719.398611 537.61858,719.28109 C542.0109,717.97609 544.92641,713.85909 547.01658,709.78152 C548.41228,707.0588 549.62595,704.08252 549.3568,701.03477 C549.08765,697.98702 546.89697,694.9167 543.8532,694.60577 C541.34383,694.34944 539.02682,695.94327 537.2167,697.7 C532.650442,702.15932 529.715809,708.024199 528.88432,714.3523 C528.48698,717.45118 528.60079,720.63438 527.75792,723.64278 C525.95824,730.06628 520.32737,734.00457 517.52127,739.78457 C514.4293,746.15351 516.13585,753.38405 519.89266,759.01926 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.75416,734.47883 C601.460499,737.488516 599.005356,739.847599 595.94646,741.02017 C594.064495,741.776105 591.988548,741.903246 590.0284,741.38262 C588.058078,740.836024 586.455125,739.40226 585.69304,737.50485 C585.393146,736.561965 585.228726,735.581257 585.20471,734.59212 C584.9231,730.26038 585.03192,725.79664 586.60536,721.75096 C587.21224,720.19054 588.0305,718.71067 588.50945,717.10635 C588.980146,715.253484 589.220957,713.34972 589.22645,711.43801 L589.74369,699.61884 C589.829227,698.760791 589.769876,697.894467 589.56812,697.0561 C589.0522,695.34593 587.45387,694.23455 585.98734,693.21469 C582.44558,690.75169 578.94559,687.87755 577.22934,683.91962 C576.639732,682.727961 576.428574,681.384516 576.62418,680.06944 C577.1081,677.72244 579.4766,676.20309 581.81762,675.69121 C584.91279,675.014438 588.150094,675.63122 590.779582,677.398674 C593.40907,679.166127 595.202577,681.930886 595.74462,685.05247 C595.97623,686.38629 595.97305,687.74874 596.10862,689.09571 C596.39618,691.95296 597.30325,694.70719 597.87071,697.52226 C599.26846,704.45636 598.54418,711.62426 599.92639,718.55714 C601.08212,724.35385 605.44,728.13625 602.75416,734.47883 Z",
    id: "Path",
    fill: "#FFB8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#44FF46",
    fillRule: "nonzero",
    cx: 563,
    cy: 687.07167,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 212,
    cy: 137.07167,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    cx: 571,
    cy: 137.07167,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualAssistant);
export default __webpack_public_path__ + "static/media/virtual_assistant.f84a6b462fae8c7928220fee4edfb1ec.svg";
export { ForwardRef as ReactComponent };